// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// TODO. Multi select ItemALL refactoring.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { TerceraInstrumentLookupDropDownForm } from './TerceraInstrumentLookupDropDownForm';
import { KeyCode } from '@shared/commons/KeyEventProcessor';
import { Resources } from '@shared/localizations/Resources';
import { LookupDropDownShowParams } from '../../UtilsClasses/LookupDropDownShowParams';
import { InstrumentLookupAutoCompleteQuickTableCell } from '../QuickTable/InstrumentLookupAutoCompleteQuickTableCell';
import { InstrumentLookupAutoCompleteQuickTableRow } from '../QuickTable/InstrumentLookupAutoCompleteQuickTableRow';
import { QuickTableColumn } from '../QuickTable/QuickTableColumn';
import { QuickTableRactive } from '../QuickTable/QuickTableRactive';
import { QuickTree } from '../QuickTree/QuickTree';
import { InstrumentLookupManager } from './InstrumentLookupManager';
import { SEPARATOR } from '@shared/utils/Enums/Constants';
import { MathUtils } from '@shared/utils/MathUtils';
import { DataCache } from '@shared/commons/DataCache';
import { TerceraSymbolLookupBaseDataProvider } from '@shared/commons/NoNFixedListCore';
import { TerceraLookup, TerceraLookupEvents } from './TerceraLookup';
import { InstrumentLookupComparer } from '@shared/utils/Instruments/InstrumentLookupComparer';
import { Instrument } from '@shared/commons/cache/Instrument';
import { InstrumentLookupProperties, InstrumentLookupType } from './InstrumentLookupManagerProps';
import { OptionType } from '@shared/utils/Instruments/OptionType';
import { InstrumentLookupQuickTreeNode } from '../QuickTree/InstrumentLookupQuickTreeNode';
import { SymbolLookupViewItemHelper } from '@shared/utils/Instruments/SymbolLookupViewItemHelper';
export class TerceraInstrumentLookup extends TerceraLookup {
    constructor() {
        super();
        this.LastFoundListCount = 0;
        this.CanMoveToNextIfHaveError = true;
        this.ItemAll = new _InstrumentItemAll();
        this.dataProvider = new TerceraSymbolLookupBaseDataProvider();
    }
    oncomplete() {
        super.oncomplete();
        this.repopulate();
    }
    getType() {
        return 'TerceraInstrumentLookup';
    }
    setFocus() {
        super.setFocus();
        void this.set({ visibleBTN: true }); // #115434
    }
    onLostFocus() {
        super.onLostFocus();
        const selI = this.get('selectedItem');
        if (!isNullOrUndefined(selI)) {
            this.setLookUpText(selI.DisplayName());
        } // #113026
    }
    getInstruments() {
        const isOptionMasterMode = this.get('isOptionMasterMode');
        const instruments = DataCache.getInstruments(isOptionMasterMode);
        return instruments;
    }
    createAutoCompleteTable() {
        const autoCompleteTablesContainer = TerceraLookup.getAutoCompleteTablesContainer();
        const qTable = new QuickTableRactive();
        void qTable.set('isAttached', false);
        void qTable.set({
            additionalClass: 'quickTableOuter-position-absolute'
        });
        autoCompleteTablesContainer.addControl(qTable);
        const quickTable = qTable.quickTable;
        quickTable.rowHeight = 40;
        void qTable.set({
            width: this.get('width') - 1,
            height: quickTable.rowHeight * this.AUTOCOMPLETE_MAX_ROWS_COUNT,
            visible: false,
            autocompleteTable: true
        });
        quickTable.columns.push(new QuickTableColumn());
        quickTable.UpdateSortedColumns();
        qTable.setShowColumnHeaders(false);
        qTable.observe('visible', this.onQTVisibilityChanged.bind(this));
        this.autoCompliteQuickTable = qTable;
    }
    selectItem(instrumentName) {
        const ins = DataCache.getInstrumentByName(instrumentName);
        if (!isNullOrUndefined(ins)) {
            void this.set('selectedItem', ins);
        }
    }
    repopulate() {
        const instruments = this.getInstruments();
        this.multiSelectDropDownItems = null;
        if (this.isMultiSelect) {
            const multiSelectItems = {};
            multiSelectItems[this.ItemAll.name] = this.ItemAll;
            for (const key in instruments) {
                multiSelectItems[key] = instruments[key];
            }
            this.setItems(multiSelectItems);
            void this.set('selectedItem', this.ItemAll);
            const multiSelectDropDownItems = this.items.slice();
            // Removing ItemAll from multiSelectDropDownItems;
            const itemAllIdx = multiSelectDropDownItems.indexOf(this.ItemAll);
            if (itemAllIdx !== -1) {
                multiSelectDropDownItems.splice(itemAllIdx, 1);
            }
            this.multiSelectDropDownItems = multiSelectDropDownItems;
        }
        else {
            this.setItems(instruments);
            const isSetDefaultInstrument = this.get('isSetDefaultInstrument');
            if (isSetDefaultInstrument) {
                // Default instrument.
                const isOptionMasterMode = this.get('isOptionMasterMode');
                const defIns = DataCache.getDefaultInstrument(isOptionMasterMode);
                const lastItem = this.get('selectedItem');
                if (isNullOrUndefined(lastItem) && !isNullOrUndefined(defIns)) {
                    void this.set('selectedItem', defIns);
                }
            }
        }
    }
    setItems(newItems) {
        if (isNullOrUndefined(newItems)) {
            return;
        }
        const keys = Object.keys(newItems);
        const items = newItems;
        const len = keys.length;
        this.items = [];
        for (let j = 0; j < len; j++) {
            const curItem = items[keys[j]];
            if (curItem.isHide) {
                continue;
            }
            this.items.push(curItem);
        }
    }
    getButtonTooltip() {
        return Resources.getResource('chart.ChartPanel.symbolLookup.ToolTip');
    }
    showForm() {
        var _a;
        super.showForm();
        const params = new LookupDropDownShowParams();
        params.x = this.getX();
        params.y = this.getY();
        if (this.isMultiSelect) {
            params.items = this.multiSelectDropDownItems;
        }
        if (!isValidArray(params.items)) {
            // SET ITEMS HERE
            this.setItems(this.getInstruments()); // GetAllInstrumentsExceptExpired());     // #113208 -> #113215 -> #113145
            params.items = this.items;
        }
        params.callBack = this.dropDownFormCallBack.bind(this);
        params.closeCallback = this.closeForm.bind(this);
        params.isMultiSelect = this.isMultiSelect;
        params.isMultiSelectMode = this.isMultiSelectMode;
        params.caller = this.get('parentContainerControl');
        if ((_a = this.selectedItem) === null || _a === void 0 ? void 0 : _a.multiSelected) {
            params.selectedItem = this.selectedItem.arraySelected;
        }
        else if (this.selectedItem === this.ItemAll) {
            params.selectedItem = params.items;
        }
        else {
            params.selectedItem = this.selectedItem;
        }
        params.dataProvider = this.dataProvider;
        params.isShowSelectAll = this.isShowSelectAll;
        params.isOptionMasterMode = this.get('isOptionMasterMode');
        TerceraInstrumentLookupDropDownForm.ShowForm(params);
    }
    fillAutoCompliteTableByItems() {
        const qTable = this.autoCompliteQuickTable;
        let findStr = '';
        if (!isNullOrUndefined(this.currentNameFilter)) {
            findStr = this.currentNameFilter.toLowerCase();
        }
        const isOptionMasterMode = this.get('isOptionMasterMode');
        if (DataCache.NonFixedList) {
            if (isOptionMasterMode) {
                void this.dataProvider.getOptionsList(findStr, null).then(function (IInstrumentsList) {
                    if (this.currentNameFilter.toLowerCase() === findStr) {
                        const sortedInstrumentList = InstrumentLookupComparer.sortOptionList(IInstrumentsList, this.currentNameFilter);
                        this.listResult(sortedInstrumentList);
                    }
                }.bind(this));
            }
            else {
                void this.dataProvider.getInstrumentsList(findStr, null, null, true, !this.get('mayContainTrees')).then(function (IInstrumentsList) {
                    if (this.currentNameFilter.toLowerCase() === findStr) {
                        const compareParams = { pattern: this.currentNameFilter, isSortByInstrumentType: true };
                        const sortedInstrumentList = InstrumentLookupComparer.sortInstrumentList(IInstrumentsList, compareParams);
                        this.listResult(sortedInstrumentList);
                    }
                }.bind(this));
            }
            return;
        }
        const items = isOptionMasterMode
            ? InstrumentLookupComparer.sortOptionList(this.items, this.currentNameFilter)
            : InstrumentLookupComparer.sortInstrumentList(this.items, {
                pattern: findStr,
                isSortByInstrumentType: true
            });
        const len = items.length;
        const qt = qTable.quickTable;
        for (let j = 0; j < len; j++) {
            const curItem = items[j];
            if (this.currentNameFilter !== null) {
                let curItemFindStr = curItem.DisplayName();
                const descr = curItem.DescriptionValue();
                curItemFindStr = (curItemFindStr + (descr ? ' (' + descr + ')' : '')).toLowerCase();
                if (!curItemFindStr.toLowerCase().includes(findStr)) {
                    continue;
                }
            }
            const isAdded = this.AddToTree(curItem, qt); // #111628
            if (!isAdded) {
                this.MakeAndAddRowByItem({ curItem, id: j, qt });
            }
        }
        for (let i = 0; i < qt.rowsArray.length; i++) {
            const row = qt.rowsArray[i];
            row.Collapsed = true;
        }
        qTable.set({ width: 400 });
        this.updateQuickTableHeight();
    }
    MakeAndAddRowByItem(props) {
        const name = props.name;
        const descr = props.descr;
        const exchng = props.exchange;
        const drawFlag = MathUtils.IsNullOrUndefined(props.drawFlag) ? true : props.drawFlag;
        const curItem = props.curItem;
        const id = props.id;
        const qt = props.qt;
        const DoCollapse = props.DoCollapse;
        const indexToInsert = props.indexToInsert;
        const visible = MathUtils.IsNullOrUndefined(props.visible) ? true : props.visible;
        const isSeriesNode = isNullOrUndefined(props.isSeriesNode) ? false : props.isSeriesNode;
        const r = new InstrumentLookupAutoCompleteQuickTableRow(curItem, id, qt, this.get('mayContainTrees'));
        r.id = id;
        r.visible = visible;
        r.DoCollapse = DoCollapse;
        r.terceraInstrumentLookup = this;
        const cell = new InstrumentLookupAutoCompleteQuickTableCell(r);
        cell.value = curItem;
        const d_name = MathUtils.IsNullOrUndefined(name) ? curItem.DisplayName() : name;
        cell.formattedValue = d_name;
        const context = qt.context;
        context.font = InstrumentLookupQuickTreeNode.Font;
        cell.InstrumentNameText = d_name;
        cell.InstrumentTradingExchangeText = exchng || curItem.TradingExchange;
        cell.InstrumentDescriptionText = MathUtils.IsNullOrUndefined(descr) ? curItem.DescriptionValue() || '' : descr;
        cell.FlagImg = drawFlag ? DataCache.CountryCache.GetFlagImage(curItem.CountryId) : null;
        cell.setInstrumentTypeDisplay(SymbolLookupViewItemHelper.getCorrectedInstrumentTypeForDisplay(curItem.InstrType, curItem.CFD));
        cell.textPattern = this.currentNameFilter;
        if (!isValidString(this.currentNameFilter) ||
            MathUtils.IsNullOrUndefined(indexToInsert) ||
            this.isMatchByFilter(cell) ||
            isSeriesNode) {
            r.cells.push(cell);
            indexToInsert ? qt.InsertRow(r, indexToInsert) : qt.AddRow(r);
            return true;
        }
        else {
            return false;
        }
    }
    listResult(foundList) {
        // "small" lookup <-> quick search in lookup text field with dropdown list <-> autoCompliteQuickTable
        const qTable = this.autoCompliteQuickTable;
        const len = foundList.length;
        this.LastFoundListCount = len;
        const qt = qTable.quickTable;
        for (let j = 0; j < len; j++) {
            const curItem = foundList[j];
            const isAdded = this.AddToTree(curItem, qt); // #111628
            if (!isAdded) {
                this.MakeAndAddRowByItem({ curItem, id: j, qt });
            }
        }
        for (const row of qt.rowsArray) {
            row.Collapsed = true;
        }
        qTable.set({ width: 400 });
        this.updateQuickTableHeight();
    }
    updateQuickTableHeight() {
        const qTable = this.autoCompliteQuickTable;
        const qt = qTable.quickTable;
        const rowHeight = qt.rowHeight;
        const rowsCount = qt.visibleRowCount();
        let visibleRowsCount = this.AUTOCOMPLETE_MAX_ROWS_COUNT;
        if (rowsCount < visibleRowsCount) {
            visibleRowsCount = rowsCount;
        }
        if (rowsCount > 0) {
            qTable.set({
                visible: true,
                height: rowHeight * visibleRowsCount + 2
            });
            qt.height = rowHeight * visibleRowsCount + 2;
            qt.updateScrollElementsCount();
        }
        else {
            qTable.set({
                visible: false
            });
        }
    }
    lookupErrorHideShow(isShow) { }
    getTypingLookupValueForSet(textValueId, defaultRow) {
        if (textValueId === 'All') {
            return this.ItemAll;
        }
        if (!isNullOrUndefined(defaultRow === null || defaultRow === void 0 ? void 0 : defaultRow.cells)) {
            const cell = defaultRow.cells[0];
            const ins = cell ? cell.value : null;
            const insName = ins ? ins.DisplayName().toLowerCase() : null;
            if (isValidString(textValueId) && insName === textValueId.toLowerCase()) {
                return ins;
            }
        }
        // return DataCache.getInstrumentByName(textValueId);     // это точно работать не будет - текстовое имя вместо interiorID
    }
    dropDownFormCallBack(result) {
        return __awaiter(this, void 0, void 0, function* () {
            const len = Array.isArray(result) ? result.length : 0;
            if (len) {
                if (len === 1) {
                    yield this.setSelectValue(result[0]);
                }
                else if (len === this.items.length) {
                    this.ItemAll.arraySelected = result;
                    yield this.setSelectValue(this.ItemAll);
                }
                else if (len < this.items.length) {
                    yield this.setSelectValue(new _InstrumentItemSelected(result));
                }
            }
            else {
                yield this.setSelectValue(result);
            }
            // TODO mb
            // this.set('labelShow', len > 1 && len < this.items.length);
        });
    }
    setSelectValue(newSelectedItem, suppressEvents) {
        return __awaiter(this, void 0, void 0, function* () {
            if (isNullOrUndefined(newSelectedItem)) {
                return;
            }
            if (newSelectedItem.FullName === 'All') {
                yield this.setSelectValueComplete(newSelectedItem);
            }
            else if (typeof newSelectedItem === 'string') {
                void this.dataProvider.getInstrumentByName(newSelectedItem);
            }
            else if (newSelectedItem.arraySelected) {
                yield this.setSelectValueComplete(newSelectedItem);
            }
            else if (newSelectedItem.GetInteriorID) {
                yield this.setSelectValueComplete(newSelectedItem);
            }
            else {
                const isOptionMasterMode = this.get('isOptionMasterMode');
                if (isOptionMasterMode) {
                    void this.dataProvider.getOption(newSelectedItem);
                }
                else {
                    void this.dataProvider.getInstrument(newSelectedItem);
                }
            }
        });
    }
    setSelectValueComplete(newInstrumen, updateItems) {
        return __awaiter(this, void 0, void 0, function* () {
            if (isNullOrUndefined(newInstrumen))
                return;
            const isOptionMasterMode = this.get('isOptionMasterMode');
            const isFakeOption = newInstrumen.optionType === OptionType.Fake;
            if (!isOptionMasterMode && isFakeOption)
                return;
            this.needCloseTableAfterClick = true;
            if (this.needChangeTreeCollapseState()) // #111628
             {
                this.updateQuickTableHeight();
                this.needCloseTableAfterClick = false;
                return;
            }
            const newText = Instrument.IsWorkingInstrument(newInstrumen) ? newInstrumen.DisplayName() : '';
            this.setLookUpText(newText);
            if (this.selectedItem === newInstrumen) {
                return;
            }
            if (!this.CanMoveToNextIfHaveError &&
                !((!!this.currentNameFilter && !!this.LastFoundListCount) ||
                    !(KeyCode.UP === this.lastKeyCode || KeyCode.DOWN === this.lastKeyCode))) {
                // apply first instrument  in case when, we entered a non-existent instrument
                this.currentNameFilter = null;
                this.LastFoundListCount = 1;
                return;
            }
            const sameInstrument = this.get('selectedItem') === newInstrumen && !isFakeOption;
            if (!sameInstrument) {
                const instrumentProvider = isOptionMasterMode
                    ? yield this.dataProvider.getOption(newInstrumen)
                    : yield this.dataProvider.getInstrument(newInstrumen); // #113311 -> иногда нет в DataCache страйка для SymbolInfo
                if (!isNullOrUndefined(instrumentProvider)) {
                    newInstrumen = instrumentProvider;
                }
                // For template data binding.
                this.selectedItem = newInstrumen;
                void this.set('selectedItem', newInstrumen);
                this.onChangeValue.Raise(newInstrumen);
                this.fire(TerceraLookupEvents.SelectedItemChanged, newInstrumen);
            }
            else {
                this.selectedItem = newInstrumen;
            }
            if (!isNullOrUndefined(updateItems)) {
                this.updateItemsAndSelectedItemIndex(newInstrumen);
            }
            else {
                this.updateSelectedItemIndex(newInstrumen);
            }
        });
    }
    updateItemsAndSelectedItemIndex(newSelectedItem) {
        this.setItems(this.getInstruments);
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i] === newSelectedItem) {
                this.selectedItemIndex = i;
                break;
            }
        }
    }
    dispose() {
        this.dataProvider.dispose();
        super.dispose();
    }
    getQuickTable() {
        const qtR = this.autoCompliteQuickTable;
        return qtR ? qtR.quickTable : null;
    }
    getFakeQuickTree() {
        if (isNullOrUndefined(this.fakeQuickTree)) {
            this.fakeQuickTree = new QuickTree(document.createElement('canvas').getContext('2d'));
        } // либо так, либо править QuickTree чтоб он(о) мог(ло) жить без DrawingContext
        return this.fakeQuickTree;
    }
    AddToTree(ins, qt) {
        // #111628
        if (!this.get('mayContainTrees')) {
            return false;
        }
        if (isNullOrUndefined(qt) || isNullOrUndefined(ins) || !ins.isOptionSymbol) // пока только для опционов
         {
            return false;
        }
        const fakeQuickTree = this.getFakeQuickTree();
        const isOptionMasterMode = this.get('isOptionMasterMode');
        const properties = new InstrumentLookupProperties(InstrumentLookupType.Small, [ins], fakeQuickTree, this.currentNameFilter);
        properties.dataProvider = this.dataProvider;
        properties.isOptionMaster = isOptionMasterMode;
        InstrumentLookupManager.fillTree(properties);
        if (isOptionMasterMode) {
            return this.generateOptionsRows(ins, qt, fakeQuickTree);
        }
        else {
            return this.generateInstrumentsRows(ins, qt, fakeQuickTree);
        }
    }
    AddToParent(parentId, ins, qt) {
        const parentRow = qt.getItemById(parentId);
        const idx = qt.rowsArray.indexOf(parentRow) + 1;
        const id = ins.GetInteriorID();
        this.MakeAndAddRowByItem({
            name: parentRow.InstrumentNameText,
            descr: parentRow.InstrumentDescriptionText,
            exchange: parentRow.InstrumentTradingExchangeText,
            id,
            curItem: ins,
            qt,
            visible: true,
            indexToInsert: idx
        });
        const childRow = qt.getItemById(id);
        if (isNullOrUndefined(childRow)) {
            this.MakeAndAddRowByItem({
                name: ins.DisplayName(),
                descr: ins.DescriptionValue(),
                exchange: ins.TradingExchange || ' ',
                id,
                curItem: ins,
                qt
            });
        }
        else {
            parentRow.AddChild(childRow);
        }
    }
    generateOptionsRows(ins, qt, fakeQuickTree) {
        var _a, _b;
        const exchangeNode = fakeQuickTree.nodeCollection[0]; //  first node (most top in "big" dropdown form) - exchange (like NYSE, NASDAQ etc.)
        if (isNullOrUndefined(exchangeNode)) {
            return false;
        }
        const insTypeNode = exchangeNode.GetFirstChild();
        const underlierNode = insTypeNode.GetFirstChild();
        const isUnderlierFutures = ins.ForwardBaseInstrument.isFuturesSymbol;
        if (isUnderlierFutures) {
            let underlierRow = qt.getItemById(underlierNode.InstrumentNameText);
            if (isNullOrUndefined(underlierRow)) {
                this.MakeAndAddRowByItem({
                    name: underlierNode.InstrumentNameText,
                    descr: underlierNode.InstrumentDescriptionText,
                    exchange: underlierNode.InstrumentTradingExchangeText || ' ',
                    id: underlierNode.InstrumentNameText,
                    curItem: ins,
                    qt
                });
                underlierRow = qt.getItemById(underlierNode.InstrumentNameText);
            }
            const indexOffset = qt.rowsArray.indexOf(underlierRow) +
                1 +
                (isValidNumber(underlierRow.ChildNum) ? underlierRow.ChildNum : 0);
            const contractNode = underlierNode.childNodes.find((node) => node.tag === ins);
            this.MakeAndAddRowByItem({
                name: contractNode.InstrumentNameText,
                descr: contractNode.InstrumentDescriptionText,
                exchange: contractNode.InstrumentTradingExchangeText || ' ',
                id: contractNode.InstrumentNameText,
                curItem: ins,
                qt,
                visible: false,
                indexToInsert: indexOffset
            });
            const contractRow = qt.getItemById(contractNode.InstrumentNameText);
            underlierRow.AddChild(contractRow);
            return true;
        }
        else {
            const exchange = (_b = (_a = ins.ForwardBaseInstrument.TradingExchange) !== null && _a !== void 0 ? _a : underlierNode.InstrumentTradingExchangeText) !== null && _b !== void 0 ? _b : ' ';
            return this.MakeAndAddRowByItem({
                name: underlierNode.InstrumentNameText,
                descr: underlierNode.InstrumentDescriptionText,
                exchange,
                id: underlierNode.InstrumentNameText,
                curItem: ins,
                qt
            });
        }
    }
    generateInstrumentsRows(ins, qt, fakeQuickTree) {
        const exchangeNode = fakeQuickTree.nodeCollection[0]; //  first node (most top in "big" dropdown form) - exchange (like NYSE, NASDAQ etc.)
        if (isNullOrUndefined(exchangeNode)) {
            return false;
        }
        const insTypeNode = exchangeNode.GetFirstChild(); //  instrument type node (text - Options, absent in "small" lookup list)
        const isInsTypeNotEmpty = !!(insTypeNode && (insTypeNode.InstrumentNameText || insTypeNode.nodeText));
        let underlierNode = isInsTypeNotEmpty
            ? insTypeNode.GetFirstChild()
            : insTypeNode.GetFirstChild().GetFirstChild(); //  fake option ins (highest level ~ most top in "small" lookup list) row
        let fakeOptionNode = underlierNode.GetFirstChild(); //  additional base ins underlier node  (may be absent)
        let seriesDateNode = fakeOptionNode.GetLastChild(); //  series option (contract date level) row
        let strikeNode = seriesDateNode ? seriesDateNode.GetLastChild() : null; //  strike row (lowest level == ins)
        if (isNullOrUndefined(strikeNode)) // => has no underlierNode (~ d)) => all childs need 1 level offset <=> data in underlierNode is fakeOptionNode (~ c)) and data in fakeOptionNode is seriesDateNode (~ b)) also data in seriesDateNode is strikeNode (~ a))
         {
            strikeNode = seriesDateNode; // a)
            seriesDateNode = fakeOptionNode; // b)
            fakeOptionNode = underlierNode; // c)
            underlierNode = null; // d)
        }
        const insID = ins.GetInteriorID(); // strike (lowest option level)
        const updIns = DataCache.getInstrumentByName(insID);
        if (!isNullOrUndefined(updIns)) {
            ins = updIns;
        }
        const parentID = InstrumentLookupAutoCompleteQuickTableRow.GetInsParentID(ins); // contract node id
        const baseOptionInsID = strikeNode ? strikeNode.tag.ForwardBaseInstrument.GetInteriorID() : parentID;
        const baseIns = ins.ForwardBaseInstrument;
        const baseInsID = baseIns ? baseIns.GetInteriorID() : null; // fake node id
        let isAdded = false;
        let id0 = baseOptionInsID !== parentID ? baseOptionInsID : underlierNode ? underlierNode.nodeText : null;
        let id1 = baseInsID;
        let id2 = parentID;
        let id3 = insID;
        let r0 = qt.getItemById(id0);
        let r1 = qt.getItemById(id1);
        let r2 = qt.getItemById(id2);
        let r3 = qt.getItemById(id3);
        if (isNullOrUndefined(r2)) {
            const splArr = parentID.split(SEPARATOR);
            let new_id2 = baseOptionInsID + SEPARATOR + splArr[2];
            r2 = qt.getItemById(new_id2);
            if (isNullOrUndefined(r2) && !isNullOrUndefined(ins.ForwardBaseInstrument)) {
                new_id2 =
                    ins.ForwardBaseInstrument.InstrumentTradableID + SEPARATOR + ins.Route + SEPARATOR + splArr[2];
            }
            r2 = qt.getItemById(new_id2);
            if (!isNullOrUndefined(r2)) {
                id2 = new_id2;
            }
        }
        if (id0 == id1) {
            if (!isNullOrUndefined(underlierNode)) {
                id0 = underlierNode.nodeText;
                r0 = qt.getItemById(id0);
            }
            else if (!isNullOrUndefined(fakeOptionNode)) {
                id1 = fakeOptionNode.nodeText;
                r1 = qt.getItemById(id1);
            }
        }
        if (!isNullOrUndefined(underlierNode) && isNullOrUndefined(r0) && id0) {
            if (this.MakeAndAddRowByItem({
                name: underlierNode.InstrumentNameText,
                descr: underlierNode.InstrumentDescriptionText,
                exchange: underlierNode.InstrumentTradingExchangeText || ' ',
                id: id0,
                curItem: baseIns,
                qt
            })) {
                isAdded = true;
            }
            r0 = qt.getItemById(id0);
        }
        if (!isNullOrUndefined(r0) && baseIns.isFutureOrOption()) {
            r0.visible = id0 !== id1;
        }
        if (isNullOrUndefined(r1)) {
            if (this.MakeAndAddRowByItem({
                name: fakeOptionNode.InstrumentNameText,
                descr: fakeOptionNode.InstrumentDescriptionText,
                exchange: fakeOptionNode.InstrumentTradingExchangeText || ' ',
                id: id1,
                curItem: baseIns,
                qt
            })) {
                isAdded = true;
            }
            r1 = qt.getItemById(id1);
        }
        if (isNullOrUndefined(r2)) {
            const splArr = id2.split(SEPARATOR);
            if (splArr.length > 1) {
                splArr[1] = baseIns.TradableRoutes[0];
                const newID2 = splArr.join(SEPARATOR);
                if (qt.getItemById(newID2)) {
                    id2 = newID2;
                }
            }
            let idx = null;
            if (!isNullOrUndefined(qt) && !isNullOrUndefined(r1)) {
                idx = qt.rowsArray.indexOf(r1) + 1;
                if (isValidNumber(r1.ChildNum)) {
                    idx += r1.ChildNum;
                }
            }
            if (this.MakeAndAddRowByItem({
                DoCollapse: seriesDateNode.DoCollapse,
                name: seriesDateNode.InstrumentNameText,
                descr: seriesDateNode.InstrumentDescriptionText,
                exchange: ' ',
                drawFlag: false,
                id: id2,
                curItem: baseIns,
                qt,
                indexToInsert: idx,
                isSeriesNode: true
            })) {
                isAdded = true;
            }
            r2 = qt.getItemById(id2);
        }
        const inNonFixedSeries = id3.indexOf('null') === 0;
        if (inNonFixedSeries) {
            id3 += ' ' + strikeNode.tag.ContractID;
        }
        if (isNullOrUndefined(r3)) {
            const idx = qt && r2 ? qt.rowsArray.indexOf(r2) + 1 : null; // index to insert (for additional option request[420] case)
            if (this.MakeAndAddRowByItem({
                name: strikeNode.InstrumentNameText,
                descr: strikeNode.InstrumentDescriptionText,
                exchange: strikeNode.InstrumentTradingExchangeText,
                id: id3,
                curItem: ins,
                qt,
                indexToInsert: idx,
                isSeriesNode: inNonFixedSeries
            })) {
                isAdded = true;
            } // strike row
            r3 = qt.getItemById(id3);
        }
        if (!isNullOrUndefined(r0) && !isNullOrUndefined(r1)) {
            r0.AddChild(r1);
        }
        if (!isNullOrUndefined(r1) && !isNullOrUndefined(r2)) {
            r1.AddChild(r2);
        }
        if (!isNullOrUndefined(r2) && !isNullOrUndefined(r3)) {
            r2.AddChild(r3);
        }
        return isAdded;
    }
    needChangeTreeCollapseState() {
        // #111628
        const visible = this.autoCompliteQuickTable.get('visible');
        if (!visible) // #113127
         {
            return false;
        }
        const qt = this.autoCompliteQuickTable.quickTable;
        const selectedRowId = qt.selectedRowIds.length ? qt.selectedRowIds[0] : null;
        const selectedRow = selectedRowId ? qt.rows[selectedRowId] : null;
        const needChange = selectedRow ? selectedRow.HasAnyChild : false;
        if (needChange) {
            selectedRow.ChangeTreeCollapseState();
        }
        return needChange;
    }
    get IsMultiSelect() {
        return this.isMultiSelect;
    }
    set IsMultiSelect(value) {
        this.isMultiSelect = value;
        this.repopulate();
    }
    isMatchByFilter(cell) {
        if (!isValidString(cell.textPattern)) {
            return false;
        }
        const matchText = cell.textPattern.toLowerCase();
        if (isValidString(cell.InstrumentNameText) && cell.InstrumentNameText.toLowerCase().includes(matchText)) {
            return true;
        }
        if (isValidString(cell.InstrumentDescriptionText) &&
            cell.InstrumentDescriptionText.toLowerCase().includes(matchText)) {
            return true;
        }
        return false;
    }
}
class _InstrumentItem {
    constructor() {
        this.FullName = 'Empty';
    }
    DisplayName() {
        return this.FullName;
    }
    DescriptionValue() {
        return this.FullName;
    }
    toString() {
        return this.FullName;
    }
    toStringWithDescr() {
        return this.FullName;
    }
}
class _InstrumentItemAll extends _InstrumentItem {
    constructor() {
        super();
        // Hide in instrument lookup dropdown.
        this.isHide = true;
        this.isLinked = false;
        this.FullName = Resources.getResource('panel.TerceraSymbolLookupDropDownForm.All');
    }
}
export class _InstrumentItemSelected extends _InstrumentItem {
    constructor(instruments) {
        super();
        this.isHide = true;
        this.isLinked = false;
        this.multiSelected = true;
        let name = '';
        const len = !isNullOrUndefined(instruments) ? instruments.length : 0;
        for (let i = 0; i < len; i++) {
            const ins = instruments[i];
            if (ins.FullName === 'All')
                continue;
            name += instruments[i].DisplayName() + ',';
        }
        // Removing comma.
        this.FullName = name.slice(0, -1);
        // Hide in instrument lookup dropdown.
        this.arraySelected = instruments;
    }
}
TerceraLookup.extendWith(TerceraInstrumentLookup, {
    data: function () {
        return {
            btnClass: 'js-lookup-show',
            name: 'TerceraInstrumentLookup',
            selectedAccount: null, // for symbol info fee (commissions and swaps depend on account selected in parent's panel account lookup)
            isInstrumentLookup: true,
            instrTypeImgConst: 0,
            isSymbolInfoOpened: false,
            mayContainTrees: false, // for options in autoCompliteQuickTable #111628
            isOptionMasterMode: false,
            isSetDefaultInstrument: true
        };
    }
});
